export default {
	init() {
		const targetElementsSelectors = ".menu_mobile, .search_wrap"; // add element classes here separated by comma
		const focusTrapElements = document.querySelectorAll(targetElementsSelectors);
		const  focusableElements = "[href], button, input, select, textarea, [tabindex]:not([tabindex='-1'])";

		document.addEventListener("keydown", function(e) {
			focusTrapElements.forEach(element => {
				const activeStateClasses = ["opened", "search_opened"]; // add element active state classes here
				const activeClassname = [...element.classList].find(classname =>
					activeStateClasses.includes(classname));

				if (activeClassname) {
					const focusableContent = element.querySelectorAll(focusableElements);
					if (focusableContent.length === 0) return;
	
					const firstFocusableElement = focusableContent[0]; // first element to be focused
					const lastFocusableElement = focusableContent[focusableContent.length - 1]; // last element to be focused

					const unfocusableSelectors = ".menu_mobile_close"; // add unfocusable element classes here separated by comma
					const hiddenFocusableElements = element.querySelectorAll(unfocusableSelectors);

					// make unfocusable elements focusable
					hiddenFocusableElements.forEach(element => {
						element.setAttribute("tabindex", 0);
					});
	
					const isTabPressed = e.key === "Tab";
			
					if (!isTabPressed) {
						return;
					}
				
					if (e.shiftKey) { // if shift key pressed for shift + tab combination
						if (document.activeElement === firstFocusableElement) {
							lastFocusableElement.focus(); // add focus for the last focusable element
							e.preventDefault();
						}
					} else { // if tab key is pressed
						if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
							firstFocusableElement.focus(); // add focus for the first focusable element
							e.preventDefault();
						}
					}
				}
			});
		});
	
	}
}
